export const CARD_TYPE = {
    MEET_NADIA: "meet_nadia",
    INSIGHTS_EMPTY: "insights_empty",
    PROFILE: "profile",
    INSIGHTS: "insights",
    SUGGESTED_TOPICS: "suggested_topics",
    ACTION_ITEMS: "action_items",
    WRAPPED_ACTION_ITEMS: "wrapped_action_items",
    FOLLOW_UP: "follow_up",
    ORGANIZATION: "organization",
    ROLE_PLAY: "role_play",
    USER_FEEDBACK: "user_feedback",
    TALENT_LIFECYCLE: "talent_lifecycle",
    WRAPPED: "wrapped",
};
